import defaultAvatar from "../../../user.png";
import { useAuthDispatch, useAuthState } from "../../../context/AuthContext";
import { BiCog } from "react-icons/bi";
import { ListGroup, ListGroupItem, Modal, ModalBody, ModalHeader, Spinner } from "react-bootstrap";
import { MdOutlineAccountTree } from "react-icons/md";
import { useState } from "react";
import { FaCheck, FaSignOutAlt } from "react-icons/fa";
import PrivateApi from "../../../services/PrivateApiService";
import { useQueryClient } from "react-query";
import { TbFiles } from "react-icons/tb";


const EnergoProfileDrop = () => {

    const API = new PrivateApi();
    const queryClient = useQueryClient();
    const { user } = useAuthState(); // state from auth
    const dispatch = useAuthDispatch();
    const [linkedAccountsModal, setLinkedAccountsModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleAccountChange = (account_id) => {
        setIsLoading(true);
        API.get_Account_switch(account_id)
            .then(resp => {
                setIsLoading(false);
                if (resp.status === 200) {
                    queryClient.invalidateQueries();
                    let db_user = resp.data.partner;
                    dispatch('LOGIN', db_user);
                    delete resp.data['partner'];
                    localStorage.setItem('token', JSON.stringify(resp.data));
                    window.location.href = db_user.x_is_house_management === true
                    ? '/hw/dashboard/'
                    : '/dashboard/';
                }
            })
            . catch(err => {
                setIsLoading(false);
                console.error(err);
            })
    }

    if (user === null) return <Spinner animation="border" />

    return (
        <>
            <div className="dropdown userDrop">
                <button
                    className="btn"
                    type="button"
                    id="profileMenuBtn"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                >
                    <img
                        src={user.image_1920 !== "False" ? `data:image/*;base64,${user.image_1920}` : defaultAvatar}
                        alt="avatar"
                        height={20}
                    />
                </button>
                <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="profileMenuBtn">

                    <li key="info" style={{ padding: 10 }}>
                        <div className="row">
                            <div className="col-12 text-center">
                                <img 
                                    src={user.image_1920 !== "False" ? `data:image/*;base64,${user.image_1920}` : defaultAvatar}
                                    alt="avatar"
                                    height={50}
                                />
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-12" style={{overflowWrap: "break-word", wordWrap: "break-word", whiteSpace: "normal", width: 250}}>
                                <p className="text-center mt-2" style={{ fontSize: 14 }}>
                                    <strong>{user.name}</strong>
                                </p>
                            </div>
                        </div>
                    </li>

                    {user.related_accounts.length > 1 &&
                        <>
                            <li className="dropdown-item" key="related-accounts">
                                <a
                                    onClick={e => { e.preventDefault(); setLinkedAccountsModal(!linkedAccountsModal) }}
                                    href="linked/"
                                    className="text-dark"
                                    style={{ display: "flex", alignItems: "center", gap: 5, textDecoration: "none"}}
                                >
                                    <MdOutlineAccountTree size={20} />
                                    Verknüpfte Konten
                                </a>
                            </li>
                            <div className="dropdown-divider"></div>
                        </>

                    }
                    {user.id === 16367 &&
                        <li className="dropdown-item" key="formularas">
                            <a 
                                href="/hw/dashboard/formulare/"
                                className="text-dark"
                                style={{ display: "flex", alignItems: "center", gap: 5, textDecoration: "none"}}
                            >
                                <TbFiles size={20} />
                                Formulare
                            </a>
                        </li>
                    }
                    <li className="dropdown-item" key="settings">
                        <a
                            href={user.x_is_house_management? "/hw/dashboard/einstellungen/":"/dashboard/einstellungen/"}
                            className="text-dark"
                            style={{ display: "flex", alignItems: "center", gap: 5, textDecoration: "none"}}
                        >
                            <BiCog size={20} />
                            Einstellungen
                        </a>
                    </li>
                    <li className="dropdown-item" key="logout">
                        <a
                            href="/logout"
                            className="text-dark"
                            style={{ display: "flex", alignItems: "center", gap: 5, textDecoration: "none"}}
                        >
                            <FaSignOutAlt size={20} />
                            Logout
                        </a>
                    </li>
                </ul>
            </div>
            {user.related_accounts &&
                <Modal show={linkedAccountsModal} onHide={() => setLinkedAccountsModal(false)}>
                    <ModalHeader closeButton hidden={isLoading}>
                        Verknüpfte Konten
                    </ModalHeader>
                    <ModalBody>
                        {isLoading ?
                        <div className="text-center">
                            <p>Konto wird gewechselt</p>
                            <Spinner animation="border" className="text-energo" />
                        </div>:
                        <>
                            <p className="text-muted"><small>
                                Hier können Sie zwischen Ihren Konten wechseln
                            </small></p>

                            {user.related_accounts.some((account) => account.company_type === "person") &&
                                <ListGroup variant="flush">
                                    {user.related_accounts.filter(acc => acc.company_type === "person").map(ra => (
                                        <ListGroupItem 
                                            onClick={() => handleAccountChange(ra.id)}
                                            key={`private-${ra.id}`}
                                            action={ra.id !== user.id}
                                            active={ra.id === user.id}
                                            style={{ display: "flex", gap: 10, alignItems: "center" }}
                                        >
                                            <img src={ra.image_1920 !== "False" ? `data:image/*;base64,${ra.image_1920}` : defaultAvatar} alt="" width={30} />
                                            {ra.name}
                                            {ra.id === user.id && <FaCheck />}
                                        </ListGroupItem>
                                    ))}
                                </ListGroup>
                            }

                            {user.related_accounts.some((account) => account.company_type === "company") &&
                                <ListGroup variant="flush" className="mt-3">
                                    <p><small>Unternehmen</small></p>
                                    {user.related_accounts.filter(acc => acc.company_type === "company").map(ra => (
                                        ra.id !== user.id ?
                                        <ListGroupItem 
                                            onClick={() => handleAccountChange(ra.id)}
                                            key={`company-${ra.id}`}
                                            active={ra.id === user.id}
                                            action={ra.id !== user.id}
                                            style={{ display: "flex", gap: 10, alignItems: "center" }}
                                        >
                                            <img src={ra.image_1920 !== "False" ? `data:image/*;base64,${ra.image_1920}` : defaultAvatar} alt="" width={30} />
                                            {ra.name}
                                            {ra.id === user.id && <FaCheck />}
                                        </ListGroupItem>:
                                        <ListGroupItem 
                                            key={`company-${ra.id}`}
                                            active={ra.id === user.id}
                                            action={ra.id !== user.id}
                                            style={{ display: "flex", gap: 10, alignItems: "center", userSelect: "none" }}
                                        >
                                        <img src={ra.image_1920 !== "False" ? `data:image/*;base64,${ra.image_1920}` : defaultAvatar} alt="" width={30} />
                                        {ra.name}
                                        {ra.id === user.id && <FaCheck />}
                                    </ListGroupItem>
                                    ))}
                                </ListGroup>
                            }
                        </>
                        }
                    </ModalBody>
                </Modal>
            }
        </>
    )
}
export default EnergoProfileDrop;